import React, { useEffect, useState } from "react";
import { getBalancePlannerRecapStatisitcs } from "../../../api/echeances";
import "./CartesStatistics.local.scss";
const CartesStatistics = ({ token, organizationId, filter }) => {
  const [statisticsData, setStatisticsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatistics = async () => {
      try {
        const response = await getBalancePlannerRecapStatisitcs(
          token,
          organizationId,
          filter.partner,
          filter.year,
          filter.collaborators,
          filter.zone,
          filter.bu,
          filter.keyWord,
          filter.status
        );
     
        setStatisticsData(response.data);
        
      } catch (error) {
        console.error("Erreur lors de la récupération des statistiques :", error);
      } finally {
        setLoading(false); 
      }
    };

    fetchStatistics();
  }, [token, organizationId, filter]);

  if (loading) {
    return <div>Chargement des données...</div>;
  }
  return (
    <div>
      <div className="grid-x align-center" style={{ width: "92%", maxWidth: "92%", margin: "auto" }}>
        <div className="cell medium-3">
          <div className="cartes">
            <div className="title_cartes">Billans planifiées</div>
            <div style={{ display: "flex", alignItems: "center" ,color: "red"}}>
              <div>
               
              </div>
              <div style={{ width: "100%" }}>
                <div className="stat" >
                  <span >Total</span>
                  <span>{statisticsData?.data?.totals?.plannedBalances} </span>
                </div>
                {statisticsData?.data?.totals?.statuses &&
                  Object.entries(statisticsData.data.totals.statuses).map(([status, value]) => (
                    <div key={status} className="stat" style={{ width: "100%" }}>
                      <span>{status}</span>
                      <span>{value} </span>
                    </div>
                  ))}
               
              </div>
            </div>
          </div>
        </div>

        <div className="cell medium-3" style={{  margin: "auto" }}>
          <div className="cartes situations-intermediares">
            <div className="title_cartes">Situations intermediares</div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <div className="stat stat_info">
                  <span style={{color: "#02af8e"}}>Situations intermediares</span>
                  <span style={{color: "#02af8e"}}>{statisticsData?.data?.totals?.intermediateSituations}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cell medium-3">
          <div className="cartes presentations">
            <div className="title_cartes">Presentations</div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <div className="stat stat_info">
                  <span style={{color: "red"}}>Presentations planifiées</span>
                  <span style={{color: "red"}}>{statisticsData?.data?.totals?.presentationsPlanned}</span>
                </div>
                <div className="stat stat_info">
                  <span style={{color: "red"}}>Presentations faites</span>
                  <span style={{color: "red"}}>{statisticsData?.data?.totals?.presentationsDone}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cell medium-3">
          <div className="cartes">
            <div className="title_cartes">heures Budgetisées & heures Réalisées</div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <div className="stat stat_info">
                  <span>heures Budgetisées </span>
                  {Math.floor(statisticsData?.data?.totals?.heuresBudgétisée)}h {Math.round((statisticsData?.data?.totals?.heuresBudgétisée % 1) * 60)}m

                </div>
                <div className="stat stat_info">
                  <span>heures Réaliséees</span>
                  {Math.floor(statisticsData?.data?.totals?.heuresrealisée)}h {Math.round((statisticsData?.data?.totals?.heuresrealisée % 1) * 60)}m


                </div>
              
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartesStatistics;
